import React from 'react';

import { Button, Text } from '@auspost/postmaster-react';

import { ReactComponent as ParcelDelivery } from 'assets/parcel-delivery.svg';
import { ReactComponent as PostBox } from 'assets/post-box.svg';
import { useAppDispatch } from 'store/store';

import { myPostBaseUrl } from '../../../config/track-config';
import { trackInteraction } from '../../../store/analytics/analytics.thunks';
import { authService } from '../../../store/customer/utils/auth0.util';
import { loginAndReturn } from '../../../utils/login.utils';

import styles from './ListPlaceholder.module.scss';

interface ListPlaceholderProp {
  isAuth?: boolean;
}
const ListPlaceholder: React.FC<ListPlaceholderProp> = ({ isAuth = false, ...props }) => {
  const dispatch = useAppDispatch();
  if (isAuth)
    return (
      <div className={styles.bannerWrapper} {...props}>
        <PostBox />
        <h3 className={styles.bannerHeading}>You’re not tracking any parcels yet</h3>
        <Text variant='body'>Add a tracking number to get started.</Text>
      </div>
    );

  const handleOnSignup = async () => {
    dispatch(trackInteraction('banner sign up'));
    if (!authService) return null;
    return await authService.signup();
  };
  const handleOnLogin = async () => {
    dispatch(trackInteraction('banner login'));
    await authService?.logout(myPostBaseUrl + '/track/', true);
    await loginAndReturn();
  };

  return (
    <div className={styles.bannerWrapper} {...props}>
      <ParcelDelivery />
      <h3 className={styles.bannerHeading}>Track everything in one place</h3>
      <Text variant='body'>Sign up to a free MyPost account to track</Text>
      <Text variant='body'>and manage your parcels across all your devices.</Text>
      <div className={styles.bannerButtonGroup}>
        <Button size='large' variant='tertiary-filled' onClick={handleOnSignup}>
          Sign up
        </Button>

        <Button size='large' variant='tertiary-filled' onClick={handleOnLogin}>
          Log in
        </Button>
      </div>
    </div>
  );
};

export default ListPlaceholder;
